import React from 'react'
import { connect } from "react-redux";
import classnames from "classnames";

import Loader from '../shared/Loader'
import Button from '../shared/Button';
import Modal from '../shared/Modal';
import baseStyles from 'custom/base.styl';

const IntroModal = (props) => {

  if (props.isFetching) {
    return <Loader absolute />
  }

  return (
    <Modal>
      <h1 className={baseStyles.title_middle}>Let’s get to know each other!</h1>
      <div className={classnames(baseStyles.centered)} key="applicant-form-modal">
        <p className={classnames(baseStyles.title_extra_small, baseStyles.mb_20)}>
          We want our applicants to receive the best experience when they become freelancers on our platform. Therefore your application process begins with a <b>short application form</b> about your educational background and field(s) of expertise. <br/>
          By filling in this form, your future account on the platform will be <b>personalized according to your preferences</b> for your convenience & productivity.
        </p>
        <p className={classnames(baseStyles.title_extra_small, baseStyles.mb_20)}>
          <b>N.B.:</b> It is prohibited to use <b>any VPN services</b> during the probation time. Please keep them turned off to avoid any technical issues on your way;)
        </p>
        <Button link onClick={props.onHideModal}>Fill in the application form</Button>
      </div>
    </Modal>
  )
}

const mapStateToProps = state => ({
  isFetching: state.profile.isFetching,
})

export default connect(mapStateToProps)(IntroModal);



// WEBPACK FOOTER //
// ./src/components/ApplicantForm/IntroModal.js